

import { useEffect } from "react";
import { Button } from "@components/ui/button";
import { Card, CardContent } from "@components/ui/card";
import { AlertCircle } from "lucide-react";

type ErrorFallbackProps = {
  error: Error & { digest?: string };
  reset: () => void;
  title?: string;
  description?: string;
};

export function ErrorFallback({
  error,
  reset,
  title = "Something went wrong",
  description = "An error occurred while loading this page.",
}: ErrorFallbackProps) {
  useEffect(() => {
    console.error("Route error:", error);
  }, [error]);

  return (
    <Card
      className="bg-card/70 border-border border-destructive/30 animate-in fade-in-0 duration-200"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <CardContent className="pt-6">
        <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10 mb-4" aria-hidden>
            <AlertCircle className="h-6 w-6 text-destructive" />
          </div>
          <h2 className="text-lg font-semibold text-foreground mb-1">{title}</h2>
          <p className="text-sm text-muted-foreground mb-6 max-w-sm">{description}</p>
          <Button onClick={reset} variant="outline" size="sm">
            Try again
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
